export default __webpack_public_path__ + "static/media/gallery_08.257c8686.jpg";